
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22.158","height":"16.788"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#1472e6","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('g',{attrs:{"opacity":".5"}},[_c('path',{attrs:{"d":"M.5.497h14.824M.5 3.497h14.824M.5 6.497h14.824M.5 9.497h14.824M.5 12.497h14.824"}})]),_c('g',{attrs:{"transform":"translate(10.989 3.996)"}},[_c('path',{attrs:{"d":"M8.787-.003H.001V1.63M3.317 12.292h5.136v-.955"}}),_c('line',{attrs:{"y2":"11","transform":"translate(5.339 .726)"}}),_c('path',{attrs:{"d":"M7.178-.003h3.49v1.634M4.257 12.292h-2.04v-.956"}})])])])
          )
        }
      }
    